import { format } from 'date-fns'
import { mapperModuleMedia } from '../../../data-layer/modules/mappers'
import imageSizes from '../../../constants/imageSizes'
import type { MapperOptions, ModuleMedia } from '#layers/core/types'
const { getI18nFormatterLocale, getDateFormatLocale } = useLocales()

export const mapperKnowledgeHubArticleSummary = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  if (!options.imageOptions) {
    options.imageOptions = {
      lazy: true,
      sizes: imageSizes.related_articles
    }
  }

  const dateFnsLocale = getI18nFormatterLocale(options.locale || 'en')
  const dateFormat = getDateFormatLocale(options.locale)
  const dateFormatted = data.date && format(new Date(data.date), dateFormat, { locale: dateFnsLocale })

  const imageOptionsWithZoom = {
    ...options.imageOptions,
    zoom: data.fpZoom
  }

  const image = mapperModuleMedia(data.image, imageOptionsWithZoom) as ModuleMedia

  // Use `getUrl` to support lazy url to link from different layers
  const linkUrl = options.getUrl!({ internalLink: { sys: data.sys } })

  // TODO: https://youtrack.is.adyen.com/issue/WEB-3642 Should we combine image and imageWithSizes and use only one?
  return {
    id: data.sys?.id,
    image: image?.medium || { src: '', alt: '' },
    imageWithSizes: image,
    title: data.title || '',
    tag: data.articleType?.name,
    link: {
      title: data.title,
      nuxt: true,
      openInNewWindow: false,
      url: linkUrl.url,
      lazyUrlEndpoint: linkUrl.lazyUrlEndpoint
    },
    dateFormatted,
    minutesToRead: data.minutesToRead,
    shortDescription: data.shortDescription || ''
  }
}
